import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb'; 
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';

import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-text-news-title-admin-config',
  templateUrl: './text-news-title-admin-config.component.html',
  styleUrls: ['./text-news-title-admin-config.component.scss']
})
export class AtwTextNewsTitleAdminConfig  extends AtwUpdateDbComponent  implements OnInit {

   @Input() type_config : string; // xác định trang đang ở page hay preview
    // @Input() id_subproject : any;
    @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
    @Input() device: any // xác định trang ở thiết bị desktop hay mobile
    @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
    @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
    @Input() staticdata: any; // là dữ liệu staticdata từ database
  
    isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
    currentViewAll: any = {};
    isCollapsed: boolean = false;
    styles_field = [
      {
        title: 'hieu_ung_chuyen_dong',
        index: 1,
      },
      {
        title: 'cau_hinh_bo_goc',
        index: 2,
      }
    ];
   
    effect_hover = [];
    effect_hover_data: any = {};
    unSelected: any;
    dataAfterChange: any  = {}
  
    text_style: any = [
      {
        title: 'tieu_de_1',
        fontSize: '68px',
        name: 'h1',
        font: 21
      },
      {
        title: 'tieu_de_2',
        fontSize: '48px',
        name: 'h2',
        font: 19
      },
      {
        title: 'tieu_de_3',
        fontSize: '36px',
        name: 'h3',
        font: 18
      },
      {
        title: 'tieu_de_4',
        fontSize: '26px',
        name: 'h4',
        font: 17
      },
      {
        title: 'tieu_de_5',
        fontSize: '20px',
        name: 'h5',
        font: 16
      },
      {
        title: 'tieu_de_6',
        fontSize: '18px',
        name: 'h6',
        font: 15
      },
      {
        title: 'van_ban',
        fontSize: '18px',
        name: 'p',
        font: 14
      },
      {
        title: 'van_ban_quan_trong',
        fontSize: '18px',
        name: 'strong',
        font: 14
      },
      {
        title: 'van_ban_nho',
        fontSize: '16px',
        name: 'small',
        font: 13
      },
      {
        title: 'trich_dan',
        fontSize: '18px',
        name: 'Blockquote',
        font: 14
      }
    ];
    /** Danh sách giải thích loại văn bản tương ứng SEO */
    seoTextTypes: any = [
      { tag: 'tieu_de_1', explain: 'dung_cho_tieu_de_chinh', usage: 'chi_dung_mot_lan_trong_trang' },
      { tag: 'tieu_de_2_den_tieu_de_6', explain: 'dung_cho_cac_tieu_de_phu', usage: 'dung_theo_thu_tu_phan_cap_khong_bo_bac' },
      { tag: 'van_ban', explain: 'dung_cho_van_ban' },
      { tag: 'van_ban_quan_trong', explain: 'dung_cho_van_ban', usage: 'chi_de_nhan_y_quan_trong_dung_tiet_che' },
    ];
    configMode: 'basic' | 'advanced' = 'basic';
    hasSelectedCell = false;
  
    constructor(
      public vhQueryAutoWeb: VhQueryAutoWeb,
      private http: HttpClient, 
      public vhEventMediator: VhEventMediator,
      @Inject(PLATFORM_ID) private platformId: Object,
      public functionService: FunctionService,
    ) {
     super(vhQueryAutoWeb, vhEventMediator, functionService);
    }
  
    ngOnInit(): void {
      // phần này get dữ liệu json
      forkJoin([
        this.http.get('assets/data/effects/text.json'),
      ]) .subscribe(([ effects]:any)=>{
        this.effect_hover = effects;
        this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      });
      this.vhQueryAutoWeb.getObject(this.objectChoosing.id_object).then((obj) => {
        this.hasSelectedCell = obj[this.device + '_config'].show_current_product || false;
      })

      if (!this.config.text_type) {
        this.config.text_type = 'p';
      }
      if (!this.config.curve) {
        this.config.curve = {
          "radius": "170",
          "angle": "100",
          "rotate": "-85",
          "isCurve": false,
          "isCurveReverse": false
        }
      }
      if (!this.class['text-news-title__curve']) {
        this.class['text-news-title__curve'] = {
          "list-style": "none",
          "font-family": "inherit",
          "width": "340px",
          "height": "340px"
        };
      }
      if (!this.class['text-news-title__curve-item']) {
        this.class['text-news-title__curve-item'] = {
          "background-image": "",
          "height": "100%",
          "left": "50%",
          "top": "0px",
          "position": "absolute",
          "transform-origin": "center",
          "font-family": "inherit"
        };
      }
    }
  
    ngOnChanges(): void {
      this.class['text-news-title__wrapper--current'] ??= {
        "color": "#fff",
        "border-top-left-radius": "0px",
        "border-top-right-radius": "0px",
        "border-bottom-left-radius": "0px",
        "border-bottom-right-radius": "0px",
        "font-family": "Arial",
        "text-decoration": "none",
        "cursor": "inherit"
      };
      this.class['text-news-title__content--current'] ??= {
        "color": "",
        "display": "-webkit-box",
        "-webkit-box-orient": "vertical",
        "overflow": "hidden",
        "-webkit-line-clamp": 3,
        "-webkit-text-stroke-width": "0",
        "-webkit-text-stroke-color": "#00a859",
        "text-align": "left",
        "text-transform": "none",
        "font-family": "inherit",
        "font-size": "18px",
        "font-style": "normal",
        "font-weight": "inherit",
        "background-image": "none",
        "-webkit-text-fill-color": "unset",
        "-webkit-background-clip": "unset",
        "word-break": "break-word"
      };
      if (this.effect_hover) {
        this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
        this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
      } 
    }
  
    /**
     * Cập nhật Đổ bóng
     */
    handleSetTextShadow() {
      this.class['text-news-title__wrapper']['filter'] = `drop-shadow(${this.config['filter']['offset_x']}px ${this.config['filter']['offset_y']}px ${this.config['filter']['blur_radius']}px ${this.config['filter']['shadow_color']})`;
    }
  
    /** Định dạng hiệu ứng văn bản (phong cách và kiểu cọ)
     * @param action : trả về hiệu ứng văn bản đã chọn
     */
    dispatchStyles(action) {
      // reset những style khác trước
      switch (action) {
        case 'Đổ bóng':
          this.config['text_style'] = 'shadow';
          this.class['text-news-title__content']['-webkit-text-stroke-width'] = "0";
          this.class['text-news-title__wrapper']['background-color'] = "";
          this.class['text-news-title__wrapper']['border-top-left-radius'] = "0px";
          this.class['text-news-title__wrapper']['border-top-right-radius'] = "0px";
          this.class['text-news-title__wrapper']['border-bottom-right-radius'] = "0px";
          this.class['text-news-title__wrapper']['border-bottom-left-radius'] = "0px";
          this.handleSetTextShadow();
          break;
  
        case 'Tạo stroke':
          this.config['text_style'] = 'stroke';
          this.class['text-news-title__wrapper']['filter'] = "";
          this.class['text-news-title__wrapper']['background-color'] = "";
          this.class['text-news-title__wrapper']['border-top-left-radius'] = "0px";
          this.class['text-news-title__wrapper']['border-top-right-radius'] = "0px";
          this.class['text-news-title__wrapper']['border-bottom-right-radius'] = "0px";
          this.class['text-news-title__wrapper']['border-bottom-left-radius'] = "0px";
          this.class['text-news-title__content']['-webkit-text-stroke-width'] = '2px';
          break;
  
        case 'background':
          this.config['text_style'] = 'background';
          this.class['text-news-title__content']['-webkit-text-stroke-width'] = "0";
          this.class['text-news-title__wrapper']['filter'] = "";
          this.class['text-news-title__wrapper']['background-color'] = "#008848";
          break;
  
        default:
          this.config['text_style'] = '';
          this.class['text-news-title__content']['-webkit-text-stroke-width'] = "0";
          this.class['text-news-title__wrapper']['filter'] = "";
          this.class['text-news-title__wrapper']['background-color'] = "";
          this.class['text-news-title__wrapper']['border-top-left-radius'] = "0px";
          this.class['text-news-title__wrapper']['border-top-right-radius'] = "0px";
          this.class['text-news-title__wrapper']['border-bottom-right-radius'] = "0px";
          this.class['text-news-title__wrapper']['border-bottom-left-radius'] = "0px";
      }
  
      this.updateObject();
    }
  
    // GRADIENT
    /**
     * Cập nhật Gradient
     */
    handleSetGradientText() {
      if (this.config['background-image'].gradient_check) {
        this.class['text-news-title__content']['background-image'] = `linear-gradient(${this.config['background-image']['background_image_direction']} ${this.config['background-image']['background_image_arr_gradient']})`;
        this.class['text-news-title__content']['-webkit-text-fill-color'] = 'transparent';
        this.class['text-news-title__content']['-webkit-background-clip'] = 'text';
      }
      else {
        this.class['text-news-title__content']['background-image'] = 'none';
        this.class['text-news-title__content']['-webkit-text-fill-color'] = 'unset';
        this.class['text-news-title__content']['-webkit-background-clip'] = 'unset';
      }
  
      this.updateObject();
    }
  
    openbgGradient() {
     
      if (isPlatformBrowser(this.platformId)) document.getElementById('input-gradient').click();
    }
    /** Hàm này cho phép chọn options direction của màu gradient
     * @param direction : trả về hướng phối màu được chọn
     * @param event : trả về element được active
     */
    chooseOption(direction, event) {
      this.config['background-image']['background_image_direction'] = direction.direction;
      this.handleSetGradientText();
    }
    /** Chuyển đổi mã màu hexadecimal thành mã màu rgba.
     * @param hex : tham số trả về mã màu hex
     * @returns string : trả về chuỗi rgb
     */
    hexToRGB(hex: string): string {
      // Loại bỏ ký tự '#' từ mã hex
      hex = hex.replace('#', '');
  
      // Tách mã hex thành các thành phần màu
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
  
      // Trả về giá trị RGB
      return `${r}, ${g}, ${b}`;
    }
    /** Xử lý lấy thông số giá trị background gradient
     * @param event : trả về giá trị từ 0-100
     */
    getValueRangeBackgroundGradient(e) {
      this.config['background-image']['background_image_opacity'] = e.target.value;
      const newArr = this.config['background-image']['background_image_arr_gradient'].map((color) => {
        const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
        return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image']['background_image_opacity'] / 100})`
      })
      this.config['background-image']['background_image_arr_gradient'] = newArr;
      
      this.handleSetGradientText();
    }
    /**
    * Hàm này thực hiện thêm màu gradient vào array.
    *
    */
    addGradient() {
      this.config['background-image']['background_image_arr_gradient'].push(
        `rgba(${this.hexToRGB(this.config['background-image']['background_image_background_color'])}, ${this.config['background-image']['background_image_opacity'] / 100})`
      );
      this.handleSetGradientText();
    }
    /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
    * @param index : vị trí phần tử muốn xóa
    */
    deleteGradient(index) {
      this.config['background-image']['background_image_arr_gradient'].splice(index, 1);
      this.handleSetGradientText();
    }
  
  
    // ANIMATION
    customize = []
    // /**
    //  * Hàm update object vào database.
    //  */
    // updateObject() {
    //   return this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
    //     .then((bool: any) => {
    //     })
    // }
  
    // /**
    //  * Hàm update class
    //  */
    // updateClass() {
    //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
    //     .then((bool: any) => {
    //     })
    // }
  
    // /**
    //  * Hàm update config
    //  */
    // updateConfig() {
    //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
    //     .then((bool: any) => {
    //     })
    // }
  
  
    /**
     * Hàm này dùng để mở rộng phần cấu hình.
     * @param field_text : trả về phần tử được chọn của mảng style_field
     */
    openViewAll(field_text) {
      this.currentViewAll = field_text;
      this.isViewAll = !this.isViewAll;
    }
  
    /**
     * Hàm này dùng để cho phép mở menu config .
     * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
     * @param: value
     */
    openHandler(value: string): void {
      for (const key in this.openMap) {
        if (key !== value) {
          this.openMap[key] = false;
        }
      }
    }
    openMap: { [name: string]: boolean } = {
      menu1: true,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false
    };
    /**
     * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
     * @param event customize sau khi thay đổi
     */
    openAnimationDetail(event) {
      this.customize = event;
      this.openViewAll(this.styles_field[0])
    }

  /**
   * Cập nhật Kiểu văn bản
   */
  handleSetTextStyle(action) {
    this.class['text-news-title__content']['font-size'] = this.text_style.find(style => style.name === action)['fontSize'];
    switch (action) {
      case "Blockquote":
        this.class['text-news-title__content']['border-left-width'] = '10px';
        this.class['text-news-title__content']['padding-left'] = '10px';
        break;
      default:
        this.class['text-news-title__content']['border-left-width'] = '0';
        this.class['text-news-title__content']['padding-left'] = '0';
    }

    // this.handleSetCurveText();

    this.updateObject();
  }
}
